import { nextTick, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'

/**
 * Located in each user type's router.vue,
 * this composable detects if refresh=true exists
 * in the query params.
 * 
 * If so, remove the query param and reload.
 */

export default function () {
  const route = useRoute()
  const router = useRouter()

  onBeforeMount(() => {
    const currentQuery = { ...route.query }
    if ('refresh' in currentQuery) {
      delete currentQuery.refresh
      router.replace({ query: currentQuery }).then(() => {
        nextTick(() => {
          window.location.reload()
        })
      })
    }
  })
}
